import { FC } from 'react'
import Image from 'next/image'
import type { Post as PostType } from 'utils/types/sanity/post'
import Link from 'next/link'
import { formatDate } from 'utils/date-utils'
import { useSanityImage } from 'utils/hooks'

interface PostCardProps extends PostType {}

export const PostCard: FC<PostCardProps> = ({
  slug,
  title,
  description,
  mainImage,
  publishedAt,
  estimatedReadingTime,
}) => {
  const imageProps = useSanityImage(mainImage)

  return (
    <Link href={`/blog/${slug}`} passHref>
      <a className='group'>
        <div className='relative aspect-[8/5]'>
          <Image
            src={imageProps.src}
            loader={imageProps.loader}
            alt={mainImage.alt}
            placeholder='blur'
            blurDataURL={imageProps.blurDataURL}
            className='group-hover:saturate-[1.25] group-hover:scale-[1.01]'
            layout='fill'
            objectFit='cover'
          />
        </div>
        <h2 className='pt-4 pb-2 text-xl font-semibold text-navy-900 group-hover:text-indigo-600'>
          {title}
        </h2>
        <p className='pb-4 text-sm text-gray-600'>{description}</p>
        <p className='text-sm uppercase text-stone-700 font-accent'>
          {publishedAt && (
            <>
              {formatDate(new Date(publishedAt))}
              <span className='px-2'>•</span>
            </>
          )}
          {estimatedReadingTime} MIN READ
        </p>
      </a>
    </Link>
  )
}
